import { usePathname } from 'next/navigation'
import { useGlobalState } from '@biolumina/ui/context/globalStateProvider'

export const usePageData = () => {
  const {
    siteData: { pageData },
  } = useGlobalState()
  const path = usePathname()?.replaceAll('/', '') || 'home'
  return pageData[path] || pageData['not-found']
}
